import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';

@Injectable({ providedIn: 'root' })
export class ZReportService extends BaseApiTemplateService<any> {
    
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +Core2Config.ERP_PREFIX + Core2Config.REPORTS_PREFIX  + 'sales/z-report';

    constructor(http: HttpClient) {
      super();
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.REPORTS_PREFIX + 'sales/z-report';
      this.httpClient = http;
    }
}